import { useEffect, useState } from "react";
import "./catalogue.css";
import Container from "../../components/Container/Container";
import CustomButton from "../../components/commons/CustomBtn";
import PromoteursList from "./components/PromoteursList";
import { useDispatch, useSelector } from "react-redux";
import AgenciesList from "./components/Agencieslist";
import { getAgencies } from "../../redux/actions/agenciesActions";
import CitiesList from "./components/CitiesList";
import getAllCities from "../../redux/actions/citiesActions";
import DiscussionList from "./components/DiscussionList";
import { getAllDiscussions } from "../../redux/actions/discussionsActions";

const Catalogue = () => {
  const dispatch = useDispatch();
  const [activeOnglet, setActiveOnglet] = useState("promoteurs");
  const { length } = useSelector((state) => state.promoteursReducer);
  const { length: agencyLength } = useSelector(
    (state) => state.agenciesReducer
  );
  const { citiesNumber } = useSelector((state) => state.citiesReducer);
  const { discussions } = useSelector((state) => state.discussionsReducer);

  useEffect(() => {
    dispatch(getAgencies());
    dispatch(getAllCities());
    dispatch(getAllDiscussions());
  }, []);

  return (
    <Container>
      <div className="d-flex gap10">
        <CustomButton
          onClick={() => setActiveOnglet("promoteurs")}
          label="Promoteurs"
          subtitle={`${length} promoteurs`}
          contentLengthClass={`${activeOnglet === "promoteurs"
              ? "regular fs11 pink "
              : "regular fs11 white"
            } `}
          buttonClass={`${activeOnglet === "promoteurs"
              ? "bg-white radiusTop5 px-20 py-10"
              : "bg-pink radiusTop5 px-20 py-10 white"
            } `}
          labelClass={`${activeOnglet === "promoteurs"
              ? "pink fs16 semibold text-capitalize text-start"
              : "white fs16 semibold text-capitalize text-start"
            }`}
        />
        <CustomButton
          onClick={() => setActiveOnglet("agences")}
          label="Agences"
          subtitle={`${agencyLength} agences`}
          contentLengthClass={`${activeOnglet === "agences"
              ? "regular fs11 pink "
              : "regular fs11 white"
            } `}
          buttonClass={`${activeOnglet === "agences"
              ? "bg-white radiusTop5 px-20 py-10"
              : "bg-pink radiusTop5 px-20 py-10 white"
            } `}
          labelClass={`${activeOnglet === "agences"
              ? "pink fs16 semibold text-capitalize text-start"
              : "white fs16 semibold text-capitalize text-start"
            }`}
        />
        <CustomButton
          onClick={() => setActiveOnglet("cities")}
          label="Villes"
          subtitle={`${citiesNumber} villes`}
          contentLengthClass={`${activeOnglet === "cities"
              ? "regular fs11 pink "
              : "regular fs11 white"
            } `}
          buttonClass={`${activeOnglet === "cities"
              ? "bg-white radiusTop5 px-20 py-10"
              : "bg-pink radiusTop5 px-20 py-10 white"
            } `}
          labelClass={`${activeOnglet === "cities"
              ? "pink fs16 semibold text-capitalize text-start"
              : "white fs16 semibold text-capitalize text-start"
            }`}
        />
        <CustomButton
          onClick={() => setActiveOnglet("ai")}
          label="AI"
          subtitle={`${discussions.length} Discussion`}
          contentLengthClass={`${activeOnglet === "ai" ? "regular fs11 pink " : "regular fs11 white"
            } `}
          buttonClass={`${activeOnglet === "ai"
              ? "bg-white radiusTop5 px-20 py-10"
              : "bg-pink radiusTop5 px-20 py-10 white"
            } `}
          labelClass={`${activeOnglet === "ai"
              ? "pink fs16 semibold text-capitalize text-start"
              : "white fs16 semibold text-capitalize text-start"
            }`}
        />
      </div>
      {activeOnglet === "promoteurs" ? <PromoteursList /> : null}
      {activeOnglet === "agences" ? <AgenciesList /> : null}
      {activeOnglet === "cities" ? <CitiesList /> : null}
      {activeOnglet === "ai" ? <DiscussionList /> : null}
    </Container>
  );
};

export default Catalogue;
